module.exports = __webpack_public_path__ + "img/round-add-24px.174436b7.svg";